var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermarkLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 751",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.4688 981.188H315.546L516.237 772.293L717.054 981.557H937.676L515.882 542.375L96.4688 981.188Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.377 -229.627H722.03L519.31 -18.7718L316.437 -230H93.5547L519.668 213.305L943.377 -229.627Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.64 702.047V583.266L890.025 372.277L1093 161.182V44.3184L981.957 44.8242L667.016 372.65L981.88 698.852L1092.64 702.047Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67.6418 44.3184V163.126L134.976 374.114L-68 585.21V702.047L43.0699 701.567L358.011 373.742L43.1467 47.5402L-67.6418 44.3184Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkLaptop);
export default __webpack_public_path__ + "static/media/watermark-laptop.c4ab2df30b43a4c705762b61e2b0bf60.svg";
export { ForwardRef as ReactComponent };